import { FC, useMemo } from 'react';

import { GameV1 } from '@/api/games';
import { GameSizeConfig } from '@/components/GameItem';
import { GameItemMode } from '@/helpers/enums';
import { GameCardFactory } from '@/modules/game/components';
import { ShowAllGameCard } from '@/modules/game/components';

import { ScLobbyGamesSlide } from './styled';
import { ColorMode } from '@/components/GameItem/styled';
import { ScGameItemPlugProps } from '@/components/GamesGrid/styled';

export type PlugType = Record<never, never>;

export interface LobbyGamesSlideProps
  extends Pick<ScGameItemPlugProps, 'plugBlack'> {
  games?: GameV1[];
  link?: string;
  rows: number;
  cols: number;
  gameItemMode?: GameItemMode;
  blackShowAllCard?: boolean;
  gameColorMode?: ColorMode;
  showAllCardSizeConfig?: GameSizeConfig;
  plugs: PlugType[];
}

export const Slide: FC<LobbyGamesSlideProps> = ({
  games,
  link,
  rows,
  cols,
  plugs,
  gameColorMode,
}) => {
  const slideGames = useMemo(
    () => (link ? games?.slice(0, games.length - 1) : games) || [],
    [games, link]
  );

  const mode = gameColorMode === ColorMode.GRAY_BG ? 'black' : 'dark';
  return (
    <ScLobbyGamesSlide rows={rows} cols={cols}>
      {slideGames.map((game) => (
        <GameCardFactory game={game} key={game.id} />
      ))}
      {plugs.map((_, index) => (
        <GameCardFactory isEmpty mode={mode} key={`empty-${index}`} />
      ))}
      {link && <ShowAllGameCard mode={mode} to={link} isShowAll />}
    </ScLobbyGamesSlide>
  );
};
